module.exports = __webpack_public_path__ + "static/media/kredyt_16.d3dbc89e.png";